import { z } from 'zod';

import { isValidGithubLogin } from './github-login';

// ---------------------------------------------------------------------------
// Per-user GitHub-org → Linear-workspace mapping. Linear has no GitHub-org
// concept, so on an org-scoped Issues/Board page the user picks which connected
// Linear workspace's issues to show. Stored in `publicMetadata.orgLinearWorkspaces`
// (see `src/types/clerk.d.ts`) and written by `POST /api/account/org-linear-map`.
// ---------------------------------------------------------------------------

/** Request body for `POST /api/account/org-linear-map`. */
export const OrgLinearMapRequestSchema = z.object({
  /** The GitHub org login the mapping is keyed by (trimmed, syntactically valid). */
  githubOrg: z.string().trim().refine(isValidGithubLogin),
  /**
   * The Linear workspace connection id (its Linear org id) to map, or `null` to
   * clear the mapping for this org.
   */
  linearConnectionId: z.string().min(1).nullable(),
});
export type OrgLinearMapRequest = z.infer<typeof OrgLinearMapRequestSchema>;
